export const EmailIcon = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.507"
      height="21.507"
      viewBox="0 0 21.507 21.507"
    >
      <path
        id="email"
        d="M10.754,21.507A10.754,10.754,0,1,1,21.507,10.754,10.766,10.766,0,0,1,10.754,21.507Zm5.577-6.976a.241.241,0,0,0,.24-.24V7.54L11.1,11.884a.556.556,0,0,1-.692,0L4.936,7.54v6.751a.241.241,0,0,0,.24.24Zm-.838-7.555-4.738,3.763L6.015,6.976Zm2.191.24v7.074a1.354,1.354,0,0,1-1.353,1.353H5.177a1.354,1.354,0,0,1-1.353-1.353V7.216A1.354,1.354,0,0,1,5.177,5.863H16.33A1.354,1.354,0,0,1,17.683,7.216Z"
        fill={primaryFontColor}
        fill-rule="evenodd"
      />
    </svg>
  );
};
